import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'

interface Props {
  /** 目标值 */
  value: number
  /** 动画持续时间（毫秒） */
  duration?: number
  /** 是否自动开始动画 */
  autoplay?: boolean
  /** 数字精度（小数位数） */
  precision?: number
  /** 是否使用分组分隔符 */
  useGrouping?: boolean
  /** 字体大小 */
  fontSize?: string
  /** 字体颜色 */
  color?: string
  /** 前缀 */
  prefix?: string
  /** 后缀 */
  suffix?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CountTo',
  props: {
    value: {},
    duration: { default: 1500 },
    autoplay: { type: Boolean, default: true },
    precision: { default: 0 },
    useGrouping: { type: Boolean, default: true },
    fontSize: { default: '' },
    color: { default: '' },
    prefix: { default: '' },
    suffix: { default: '' }
  },
  emits: ["on-start", "on-finish"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const currentValue = ref(0)
let animationFrameId: number | null = null
let startTime: number | null = null
let startValue = 0

// 计算显示的格式化值
const formattedValue = computed(() => {
  const num = Number(currentValue.value.toFixed(props.precision))
  let result = num.toLocaleString(undefined, {
    minimumFractionDigits: props.precision,
    maximumFractionDigits: props.precision,
    useGrouping: props.useGrouping
  })

  if (props.prefix) result = props.prefix + result
  if (props.suffix) result = result + props.suffix

  return result
})

// 计算样式
const computedStyle = computed(() => {
  const style: Record<string, string> = {}
  if (props.fontSize) style.fontSize = props.fontSize
  if (props.color) style.color = props.color
  return style
})

// 缓动函数 - 二次缓出
const easeOutQuad = (t: number): number => t * (2 - t)

const animate = (timestamp: number) => {
  if (!startTime) startTime = timestamp
  const elapsed = timestamp - startTime
  const progress = Math.min(elapsed / props.duration, 1)

  currentValue.value = startValue + (props.value - startValue) * easeOutQuad(progress)

  if (progress < 1) {
    animationFrameId = requestAnimationFrame(animate)
  } else {
    stopAnimation()
    emit('on-finish')
  }
}

const startAnimation = () => {
  stopAnimation()
  startValue = currentValue.value
  startTime = null
  emit('on-start')
  animationFrameId = requestAnimationFrame(animate)
}

const stopAnimation = () => {
  if (animationFrameId) {
    cancelAnimationFrame(animationFrameId)
    animationFrameId = null
  }
}

const reset = () => {
  stopAnimation()
  currentValue.value = 0
}

watch(() => props.value, (newVal, oldVal) => {
  if (props.autoplay && newVal !== oldVal) {
    startAnimation()
  }
})

onMounted(() => {
  currentValue.value = props.value
  if (props.autoplay) {
    startAnimation()
  }
})

onUnmounted(() => {
  stopAnimation()
})

// 暴露方法给父组件
__expose({
  start: startAnimation,
  stop: stopAnimation,
  reset
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "count-to",
    style: _normalizeStyle(computedStyle.value)
  }, _toDisplayString(formattedValue.value), 5))
}
}

})